import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-targetting-engine-override',
  templateUrl: './targetting-engine-override.component.html',
  styleUrls: ['./targetting-engine-override.component.scss']
})
export class TargettingEngineOverrideComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
